<div class="login-grid" *ngIf="!isAuthLoading && showLoginUI">
    <app-error-popup [show]="showErrorPopup" [errorMessage]="currentErrorMessage" (close)="onCloseErrorPopup()"></app-error-popup>
<div class="login-user">
    <div class="login-pharma">
        <div class="login-pharma-img">
            <span *ngIf="pharmacyLogo"><img alt="Pharmacy" [src]="pharmacyLogo" class="phrmaLogo-bg"></span>
            <span>{{pharmacyInfo?.name}}</span>
            <p *ngIf="pharmacyInfo?.phone">Ph: {{pharmacyInfo?.phone | pharmNumberformat}}</p>
        </div>
        <div class="login-pharma-img laptop">
            <img alt="Pharmacy" src="../assets/images/pharma-laptop.png">
        </div>
    </div>
    <div class="login-access">
        <div class="title">Access Your Account</div>
        <div class="login-form">
                <div class="box-sec login-section" (click)="signUpWithRedirect()" *ngIf="isNewUser">
                    <img src="../assets/images/login-user.png" alt="Login">
                    <div class="login-title">
                        <span class="login-heading">Sign Up</span>
                        <span class="login-text">Sign Up with Email and Password.</span>
                    </div>
                    <div class="login-arrow">
                        <img src="../assets/images/right-arrow.png" alt="" aria-hidden="true">
                    </div>
                </div>
                <div class="box-sec login-section" (click)="loginWithRedirect()" *ngIf="!isNewUser">
                    <img src="../assets/images/login-user.png" alt="Login">
                    <div class="login-title">
                        <span class="login-heading">Login</span>
                        <span class="login-text">Login with Email and Password.</span>
                    </div>
                    <div class="login-arrow">
                        <img src="../assets/images/right-arrow.png" alt="" aria-hidden="true">
                    </div>
                </div>
                <div class="box-sec guest-section" (click)="continueAsGuest()" *ngIf="isGuestCheck">
                    <img src="../assets/images/user-pwd.png" alt="Continue as Guest">
                    <div class="login-title">
                        <span class="guest">Continue as Guest</span>
                        <span class="guest-text">Login with OTP</span>
                    </div>
                    <div class="login-arrow">
                        <img src="../assets/images/right-arrow.png" alt="" aria-hidden="true">
                    </div>
                </div>
        </div>
        <div class="powerd-by">Powered by <img src="../assets/images/login-powerby.svg" alt="Powered by"></div>
    </div>
</div>
</div>
<div class="copyRight" *ngIf="!isAuthLoading && showLoginUI">&copy; Copyright {{currentYear}}. All rights reserved.</div>
